<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Maintenance Data
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="str"
              :label="this.localForm.str"
              :items="maintStrategyTypeOptions"
              color="wplblue0"
              prepend-icon="app_registration"
              hint="maintenance strategy"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.req"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="build"
            hint="maintenance requirement"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="accl"
              :label="this.localForm.accl"
              :items="accessLevel"
              color="wplblue0"
              prepend-icon="login"
              hint="access level"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="acct"
              :label="this.localForm.acct"
              :items="accessType"
              color="wplblue0"
              prepend-icon="view_day"
              hint="access type"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="isol"
              :label="this.localForm.isol"
              :items="isolationLevel"
              color="wplblue0"
              prepend-icon="lock_clock"
              hint="isolation level"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="isot"
              :label="this.localForm.isot"
              :items="isolationType"
              color="wplblue0"
              prepend-icon="lock"
              hint="isolation type"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.keym"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="key"
            hint="maintenance key"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.isok"
            :rules="ruleMustBeFilledANDLessThan100"
            prepend-icon="enhanced_encryption"
            hint="isolation key"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Asset Maintenance Guide
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.maint"
            label="Asset Maintenance planning and execution"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="facility comments on access or isolations or other"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import selectAsset from "@/data/options/mixins/selectAsset.js";
import strategyOptions from "@/data/options/mixins/strategyOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        isol: "",
        isot: "",
        accl: "",
        acct: "",
        maint: "",
        str: "",
        req: "",
        isok: "",
        keym: ""
      },
      orgForm: {
        isol: "",
        isot: "",
        accl: "",
        acct: "",
        maint: "",
        str: "",
        req: "",
        isok: "",
        keym: ""
      },
      isol: "",
      isot: "",
      accl: "",
      acct: "",
      maint: "",
      str: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    str() {
      this.localForm.str = this.str;
      this.updateFormChar();
    },
    isol() {
      this.localForm.isol = this.isol;
      this.updateFormChar();
    },
    isot() {
      this.localForm.isot = this.isot;
      this.updateFormChar();
    },
    accl() {
      this.localForm.accl = this.accl;
      this.updateFormChar();
    },
    acct() {
      this.localForm.acct = this.acct;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.maint = this.getDetail.char.maint;
    this.localForm.acct = this.getDetail.char.acct;
    this.localForm.isot = this.getDetail.char.isot;
    this.localForm.isol = this.getDetail.char.isol;
    this.localForm.accl = this.getDetail.char.accl;
    this.localForm.str = this.getDetail.char.str;
    this.localForm.req = this.getDetail.char.req;
    this.localForm.keym = this.getDetail.char.keym;
    this.localForm.isok = this.getDetail.char.isok;

    this.orgForm.maint = this.getDetail.char.maint;
    this.orgForm.acct = this.getDetail.char.acct;
    this.orgForm.isot = this.getDetail.char.isot;
    this.orgForm.isol = this.getDetail.char.isol;
    this.orgForm.accl = this.getDetail.char.accl;
    this.orgForm.str = this.getDetail.char.str;
    this.orgForm.req = this.getDetail.char.req;
    this.orgForm.keym = this.getDetail.char.keym;
    this.orgForm.isok = this.getDetail.char.isok;
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    selectAsset,
    strategyOptions
  ],
  // components: {
  //   RoleDevelopmentManageCard,
  //   RoleDevelopmentSummaryCard
  // },
  computed: {
    ...mapGetters(["getDetail", "getDetailChar"]),
    userStatus() {
      let status = null;
      if (this.getDetail.basic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.str !== this.orgForm.str &&
        this.localForm.str !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.str = this.localForm.str;
        // basic
        char.str = this.localForm.str;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.41, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.req !== this.orgForm.req &&
        this.localForm.req !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.req = this.localForm.req;
        // basic
        char.req = this.localForm.req;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.isot !== this.orgForm.isot &&
        this.localForm.isot !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.isot = this.localForm.isot;
        // basic
        char.isot = this.localForm.isot;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.isol !== this.orgForm.isol &&
        this.localForm.isol !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.isol = this.localForm.isol;
        // basic
        char.isol = this.localForm.isol;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.acct !== this.orgForm.acct &&
        this.localForm.acct !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.acct = this.localForm.acct;
        // basic
        char.acct = this.localForm.acct;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.accl !== this.orgForm.accl &&
        this.localForm.accl !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.accl = this.localForm.accl;
        // basic
        char.accl = this.localForm.accl;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.maint !== this.orgForm.maint &&
        this.localForm.maint !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.maint = this.localForm.maint;
        // basic
        char.maint = this.localForm.maint;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.keym !== this.orgForm.keym &&
        this.localForm.keym !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.keym = this.localForm.keym;
        // basic
        char.keym = this.localForm.keym;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.isok !== this.orgForm.isok &&
        this.localForm.isok !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.isok = this.localForm.isok;
        // basic
        char.isok = this.localForm.isok;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.81, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
